import axios from "axios";
import setupInterceptors from "./interceptors";

const apiBase = axios.create({
  baseURL: process.env.VUE_APP_API_BACK_URL,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

// Injecte token + gestion erreurs
setupInterceptors(apiBase);

export default apiBase;
